import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { getFirebaseFirestore } from "@/config/firebase";
import { isDemoMode } from "@/demo/demoMode";
import * as demoStore from "@/demo/demoStore";
import type {
  Movement,
  MovementCategory,
} from "@vlab-corporation/vlab-pilates-service-interface/movement";

function movementsCollection(ownerUid: string, centerId: number) {
  return collection(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "movements",
  );
}

export async function getMovements(ownerUid: string, centerId: number): Promise<Movement[]> {
  if (isDemoMode()) return demoStore.getMovements(centerId);
  const q = query(movementsCollection(ownerUid, centerId), orderBy("category"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Movement);
}

export async function getMovementsByCategory(
  ownerUid: string,
  centerId: number,
  category: MovementCategory,
): Promise<Movement[]> {
  if (isDemoMode()) return demoStore.getMovementsByCategory(centerId, category);
  const q = query(
    movementsCollection(ownerUid, centerId),
    where("category", "==", category),
    orderBy("name"),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Movement);
}

export function searchMovements(movements: Movement[], keyword: string): Movement[] {
  const lower = keyword.toLowerCase().trim();
  if (!lower) return movements;
  return movements.filter(
    (m) =>
      m.name.toLowerCase().includes(lower) ||
      (m.description && m.description.toLowerCase().includes(lower)),
  );
}
